import { isMobile } from 'react-device-detect';

export const deviceTypeByState = () => (isMobile ? 'mobile' : 'desktop');

export const getApiUrl = () => {
  if (window.location.hostname.includes('dev')) {
    return 'https://dev-api.armedconflict.law/';
  }

  if (window.location.hostname.includes('localhost')) {
    return 'https://dev-api.armedconflict.law/';
  }

  return 'https://api.armedconflict.law/';
};
